import { Box } from '@material-ui/core';

import { TAgentNav } from '../../../interfaces';
import { Nav } from './Nav';

import { useStyles } from './style';

export const AgentNavbar = () => {
  const classes = useStyles();

  const navs: TAgentNav[] = ['customer_info', 'canned_responses'];

  return (
    <Box className={classes.wrapper}>
      <Box className={classes.navigation}>
        {navs.map((i) => (
          <Nav type={i} key={i} />
        ))}
      </Box>
    </Box>
  );
};
